export class RouteParamsHandler {
  constructor(router, options = {}, perPage = 32) {
    this.perPage = perPage;
    this.router = router;
    this.options = {
      cryptosParam: "cryptos",
      networksParam: "networks",
      pageParam: "page",
      sortByParam: "sortBy",
      sortDescParam: "sortDesc",
      perPageParam: "perPage",
      searchParam: "search",
      sourcesParams: "sources",
      tokenTypesParam: "tokenTypes",
      ...options,
    };
    this.isInitialLoad = true;
  }

  encodeChainId(chainId) {
    if (chainId === null || chainId === undefined) {
      return "";
    }

    const strChainId = String(chainId);

    if (/^\d+$/.test(strChainId)) {
      return strChainId;
    }

    return encodeURIComponent(strChainId);
  }

  decodeChainId(encodedChainId) {
    if (!encodedChainId) {
      return "";
    }

    if (/^\d+$/.test(encodedChainId)) {
      return encodedChainId;
    }

    try {
      return decodeURIComponent(encodedChainId);
    } catch (e) {
      console.error("Error decoding chainId:", e);
      return encodedChainId;
    }
  }

  initializeFiltersFromRoute() {
    const query = this.router.currentRoute.query;
    const {
      cryptosParam,
      networksParam,
      pageParam,
      sortByParam,
      sortDescParam,
      perPageParam,
      sourcesParams,
      searchParam,
      tokenTypesParam,
    } = this.options;

    let selectedNetworks = [];

    if (!query[searchParam] && query[networksParam]) {

      const cleanNetworksParam = query[networksParam].replace(/[}]/g, "");

      selectedNetworks = cleanNetworksParam.split(",").map((id) => {
        // For numeric IDs, convert to number to ensure consistent comparison
        if (/^\d+$/.test(id)) {
          return parseInt(id, 10);
        }
        return this.decodeChainId(id);
      });
    }

    return {
      selectedCryptos: query[searchParam]
        ? []
        : query[cryptosParam]
          ? query[cryptosParam].split(",")
          : [],
      selectedNetworks,
      selectedSources: query[searchParam]
        ? []
        : query[sourcesParams]
          ? query[sourcesParams].split(",")
          : [],
      tokenTypes: query[searchParam]
        ? []
        : query[tokenTypesParam]
          ? query[tokenTypesParam].split(",")
          : [],
      currentPage: query[pageParam] ? parseInt(query[pageParam]) : 1,
      sortBy: query[sortByParam] || "popularity",
      sortDesc: query[sortDescParam] === "true",
      perPage: query[perPageParam]
        ? parseInt(query[perPageParam])
        : this.perPage,
      searchTerm: query[searchParam] || "",
    };
  }

  updateRouteParams(params) {
    if (this.isInitialLoad) return;

    const query = { ...this.router.currentRoute.query };
    const {
      cryptosParam,
      networksParam,
      sourcesParams,
      pageParam,
      sortByParam,
      sortDescParam,
      perPageParam,
      searchParam,
      tokenTypesParam,
    } = this.options;

    if (params.searchTerm !== undefined) {
      if (params.searchTerm) {
        query[searchParam] = params.searchTerm;
        delete query[cryptosParam];
        delete query[networksParam];
        delete query[tokenTypesParam];
      } else {
        delete query[searchParam];
      }
    }

    if (params.selectedCryptos !== undefined) {
      if (params.selectedCryptos.length > 0) {
        query[cryptosParam] = params.selectedCryptos.join(",");
      } else {
        delete query[cryptosParam];
      }
    }

    if (params.selectedNetworks !== undefined) {
      if (params.selectedNetworks.length > 0) {
        // Use different encoding strategy based on chainId type
        query[networksParam] = params.selectedNetworks
          .map((id) => this.encodeChainId(id))
          .join(",");
      } else {
        delete query[networksParam];
      }
    }

    if (params.selectedSources !== undefined) {
      if (params.selectedSources.length > 0) {
        query[sourcesParams] = params.selectedSources.join(",");
      } else {
        delete query[sourcesParams];
      }
    }

    if (params.tokenTypes !== undefined) {
      if (params.tokenTypes.length > 0) {
        query[tokenTypesParam] = params.tokenTypes.join(",");
      } else {
        delete query[tokenTypesParam];
      }
    }

    if (params.currentPage !== undefined) {
      query[pageParam] = params.currentPage.toString();
    }

    if (params.sortBy !== undefined) {
      query[sortByParam] = params.sortBy;
    }

    if (params.sortDesc !== undefined) {
      query[sortDescParam] = params.sortDesc.toString();
    }

    if (params.perPage !== undefined) {
      query[perPageParam] = params.perPage.toString();
    }

    this.router.replace({ query }).catch((err) => {
      if (err.name !== "NavigationDuplicated") {
        console.warn("Navigation duplicated:", err);
      }
    });
  }

  setInitialLoadComplete() {
    this.isInitialLoad = false;
  }
}
